import React from 'react';
import NewsItem from './NewsItem';
import { NewsItem as NewsItemType } from './useNewsData';

interface MobileNewsProps {
    newsItems: NewsItemType[];
    bulletStyle: string;
    cvLink: string;
}

const MobileNews: React.FC<MobileNewsProps> = ({ newsItems, bulletStyle, cvLink }) => {
    return (
        <>
            <p className="text-textGrey font-condensed text-center font-extralight text-lg">
                Most Updated <a className="text-textRed hover:underline" href={cvLink}>CV</a>
            </p>
            <br />
            <ul className="list-mobile text-textGrey text-md text-left font-condensed font-extralight md:w-[95vw] sm:w-[93vw] h-auto">
                {newsItems.map((item, index) => (
                    <li key={index} className={`relative pl-6 mx-10 ${bulletStyle}`}>
                        <div className="flex flex-row">
                            <span>{item.date}</span>
                            <span className="mx-1">-</span>
                            <span>
                                {item.title}
                                {/* Country Flag */}
                                {(() => {
                                    const codes = item.countryCode.split('-');
                                    return codes.map((code, idx) => (
                                        <img
                                            key={idx}
                                            alt={`${item.country} Flag`}
                                            src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${code}.svg`}
                                            className={`w-4 inline-block align-middle mx-1 mb-0.5 ${
                                                code === 'ID' || code === 'SG' ? 'border border-1' : ''
                                            }`}
                                            width={4}
                                            height={4}
                                            loading="lazy"
                                        />
                                    ));
                                })()}
                            </span>
                        </div>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default MobileNews;